export default __webpack_public_path__ + "static/media/video.b7d3fdcb.svg";